//Api
import { hasHardwareAsync, isEnrolledAsync, authenticateAsync } from 'expo-local-authentication'
import { logger } from 'APP/Lib/Datadog'

// I18n
import I18n from 'APP/I18n'

export const APP_LOCK_STATE = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  SUPPORTED: 'supported',
  NOT_SUPPORTED: 'notSupported',
  NOT_ENROLLED: 'notEnrolled',
  ENABLED_BLOCKED: 'enabledBlocked',
}

export async function biometricsAvailable() {
  try {
    const hardware = await hasHardwareAsync()
    const enrolled = await isEnrolledAsync()
    return hardware && enrolled
  } catch (error) {
    logger.error('biometricsAvailable rejection', {}, error)
    return false
  }
}

export async function biometricsState() {
  try {
    const hardware = await hasHardwareAsync()
    const enrolled = await isEnrolledAsync()
    if (hardware && enrolled) {
      return APP_LOCK_STATE.SUPPORTED
    } else if (!hardware) {
      return APP_LOCK_STATE.NOT_SUPPORTED
    } else {
      return APP_LOCK_STATE.NOT_ENROLLED
    }
  } catch (error) {
    logger.error('biometricsAvailable rejection', {}, error)
    return false
  }
}

export async function triggerBiometrics() {
  try {
    return await authenticateAsync({
      promptMessage: I18n.t('AppLock.promptMessage'),
      cancelLabel: I18n.t('AppLock.cancelMessage'),
      disableDeviceFallback: false,
    })
  } catch (error) {
    logger.error('triggerBiometrics rejection', {}, error)
    return false
  }
}
